import { hydrateRoot } from 'react-dom/client'
import { applyEnvironmentWatermark } from '@/common/lib/environmentWatermark'
import '@/common/styles/environmentWatermark.css'
import './app/styles/index.css'
import { Landing } from './pages/Landing'

applyEnvironmentWatermark()

const App = () => {
    return <Landing />
}

export default App

const rootElement = document.getElementById('root')
if (rootElement) {
    hydrateRoot(rootElement, <App />)
}
